import { render, staticRenderFns } from "./TextPrep.vue?vue&type=template&id=04eab1c0&scoped=true&"
import script from "./TextPrep.vue?vue&type=script&lang=js&"
export * from "./TextPrep.vue?vue&type=script&lang=js&"
import style0 from "./TextPrep.vue?vue&type=style&index=0&id=04eab1c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eab1c0",
  null
  
)

export default component.exports